import request from '@/utils/request'

// 分页查询业绩目标列表
export function listByPage(data) {
  return request({
    url: '/performanceTarget/listByPage',
    method: 'post',
    data: data
  })
}
// 删除业绩目标
export function delteKpi(data) {
  return request({
    url: '/performanceTarget/delete',
    method: 'post',
    data: data
  })
}

// 保存业绩目标
export function saveKpi(data) {
  return request({
    url: '/performanceTarget/save',
    method: 'post',
    data: data
  })
}


export function queryAtList(query) {
  return request({
    url: '/crmFollow/queryAtList',
    method: 'get',
    params: query
  })
}
